module.exports = __webpack_public_path__ + "img/top-box-lucky.2d11f28e.png";